<app-toolbar></app-toolbar>
<div class="content">
  <app-sidebar (sidebarToggled)="sidebarOpen = $event" />
  <div class="main-content" [ngClass]="{ collapsed: !sidebarOpen }">
    <div class="main-inner" role="main">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<app-footer></app-footer>
